// FIX: Add import for React to resolve namespace error.
import React, { useCallback, Dispatch, SetStateAction } from 'react';
import { GameState } from '../../domain/entities';
import { listSaves as listSavesFromDb, getSave, saveGame, deleteSave, SaveFile } from '../../infrastructure/GameStateRepository';
import { migrate } from '../../services/MigrationService';
import { PlayerGenerator } from '../../services/playerGenerator';

type SetGameState = Dispatch<SetStateAction<GameState | { gameStarted: false; }>>;

interface UsePersistenceProps {
    gameState: GameState | { gameStarted: false };
    setGameState: SetGameState;
}

export const usePersistence = ({ gameState, setGameState }: UsePersistenceProps) => {

    const listSaves = useCallback(async (): Promise<SaveFile[]> => {
        return await listSavesFromDb();
    }, []);

    const loadNamedGame = useCallback(async (id: number): Promise<boolean> => {
        const loadedState = await getSave(id);
        if (loadedState) {
            try {
                const migratedState = migrate(loadedState);
                if (migratedState.gameStarted) {
                    PlayerGenerator.initializePlayerIdCounter(migratedState);
                }
                setGameState(migratedState);
                return true;
            } catch (e: any) {
                console.error(`Migration failed for save ${id}: ${e.message}`);
                return false;
            }
        }
        return false;
    }, [setGameState]);
    
    const saveNamedGame = useCallback(async (id: number | null, name: string): Promise<boolean> => {
        if (gameState.gameStarted) {
            await saveGame(id, name, gameState);
            return true;
        }
        return false;
    }, [gameState]);

    const deleteNamedGame = useCallback(async (id: number): Promise<void> => {
        await deleteSave(id);
    }, []);

    const loadFullGameState = useCallback((newState: GameState) => {
        if (newState.gameStarted) {
            PlayerGenerator.initializePlayerIdCounter(newState);
        }
        setGameState(newState);
    }, [setGameState]);

    return {
        listSaves,
        loadNamedGame,
        saveNamedGame,
        deleteNamedGame,
        loadFullGameState,
    };
};